import { FormInstance } from 'antd';
import { StoreValue } from 'antd/es/form/interface';
import { differenceWith, fromPairs, isEqual, toPairs } from 'lodash';

import { RecursiveRequired, ValueOf } from 'types';

export const getFormChanges = <T extends Record<string, ValueOf<T>>>(
  initialValues: T,
  form: FormInstance<RecursiveRequired<T>>,
) => {
  const formValues = form.getFieldsValue();

  const difference = differenceWith(toPairs(formValues), toPairs(initialValues), isEqual);

  const toObject = fromPairs(difference) as T;

  return toObject;
};

export const getNestedFormChanges = <T extends Record<string, StoreValue>>(
  initialValues: T,
  form: FormInstance<RecursiveRequired<T>>,
) => {
  const difference = (formValues: T, initValues: T) => Object.keys(formValues).reduce((acc, key) => {
    const formV = formValues[key];
    const initV = initValues[key];

    const nestedDiff = formV
      ? differenceWith(toPairs(formV), toPairs(initV), isEqual)
      : null;

    if (nestedDiff) {
      acc[key] = fromPairs(nestedDiff);
    }

    return acc;
  }, {} as StoreValue);

  const formFieldValues = form.getFieldsValue();

  const nestedDifference: T = difference(formFieldValues as T, initialValues);

  return nestedDifference;
};
